export const getAPIURL = (originalOrigin) => {
  // Split the original origin into its components
  const url = new URL(originalOrigin || window.location.origin);

  // Remove "www" prefix if it exists
  if (url.hostname.startsWith("www.")) {
    url.hostname = url.hostname.slice(4); // Remove the "www."
  }

  // Check if the URL starts with "local." and return it as-is
  if (url.hostname.startsWith("local.")) {
    return url.origin;
  }

  if (url.hostname.startsWith("portal.")) {
    // Replace "portal" with "api"
    url.hostname = `api.${url.hostname.slice(7)}`;
    return url.origin;
  }

  // TODO: temporary fix for host name start with frontend
  // Check if the URL starts with "frontend."
  if (url.hostname.startsWith("frontend.")) {
    // Replace "frontend" with "api.dev"
    url.hostname = `api.dev.${url.hostname.slice(9)}`;
    return url.origin;
  }

  // Check if the URL starts with "frontend-qa."
  if (url.hostname.startsWith("frontend-qa.")) {
    // Replace "frontend" with "api.qa"
    url.hostname = `api.qa.${url.hostname.slice(12)}`;
    return url.origin;
  }

  // Check if the URL starts with "frontend-uat."
  if (url.hostname.startsWith("frontend-uat.")) {
    // Replace "frontend" with "api.uat"
    url.hostname = `api.uat.${url.hostname.slice(13)}`;
    return url.origin;
  }

  // Check if "api" subdomain is already present
  if (!url.hostname.startsWith("api.")) {
    // Append "api" as a subdomain
    url.hostname = `api.${url.hostname}`;
  }

  // Reconstruct and return the new origin
  return url.origin;
};
